module.exports = __webpack_public_path__ + "static/october-2-d5995804b38778895e2d36cd8ce63615.png";